import React, { FC } from 'react'
import { TailSpin } from 'react-loader-spinner'

import styles from './styles.module.css'

type Props = {
  children: React.ReactNode | string
  cssClassName?: {
    container?: string
    label?: string
  }
  labelColor?: string
  backgroundColor?: string
  width?: number | string
  isLoading?: boolean
  isDisabled?: boolean
  loadingIndicatorSize?: number
  onClick: () => void
}

const default_backgroundColor = '#0b6ab3'
const default_labelColor = '#fff'
const default_loadingIndicatorSize = 20

export const FilledButton: FC<Props> = ({
  cssClassName,
  children,
  backgroundColor,
  labelColor,
  width,
  isDisabled,
  isLoading,
  loadingIndicatorSize,
  onClick,
}) => {
  return (
    <button
      style={{
        backgroundColor: backgroundColor || default_backgroundColor,
        width,
      }}
      disabled={isDisabled || isLoading}
      className={`${styles.container} ${cssClassName?.container}`}
      onClick={onClick}
    >
      {isLoading ? (
        <TailSpin
          color={labelColor || default_labelColor}
          width={loadingIndicatorSize || default_loadingIndicatorSize}
          height={loadingIndicatorSize || default_loadingIndicatorSize}
        />
      ) : (
        <label
          style={{ color: labelColor || default_labelColor }}
          className={`${styles.label} ${cssClassName?.label}`}
        >
          {children}
        </label>
      )}
    </button>
  )
}
